import React, { ComponentType } from 'react'
import {
  Header,
  Message
} from 'semantic-ui-react'
// Local
import { LoginLogo } from '../common/brandingUtils'
import If from '../common/if'
import { shouldRenderReskin2025 } from '../../constant'
import ReveleerCoachingBox from '../ReveleerCoachingBox'

const SafeHeader = Header as unknown as ComponentType<any>

type Props = {
  errorMessage: string | null
  infoMessage: string | null
}

function LoginEmpty(
  props: Props
) {
  const {
    errorMessage,
    infoMessage
  } = props
  return (
    <div>
      <SafeHeader
        as="h2"
        textAlign="center"
      >
        <Header.Content>
          { LoginLogo() }
        </Header.Content>
      </SafeHeader>
      <If isTrue={ errorMessage != null }>
        <If isTrue={ !shouldRenderReskin2025 }>
          <Message
            error={ true }
            content={ errorMessage }
          />
        </If>
        <If isTrue={ shouldRenderReskin2025 }>
          <ReveleerCoachingBox
            coachingBoxType="error"
            isShowing
            message={
              <p>{ errorMessage }</p>
            }
          />
        </If>
      </If>
      <If isTrue={ infoMessage != null }>
        <If isTrue={ !shouldRenderReskin2025 }>
          <Message content={ infoMessage } />
        </If>
        <If isTrue={ shouldRenderReskin2025 }>
          <ReveleerCoachingBox
            coachingBoxType="infoNegative"
            isShowing
            message={
              <p>{ infoMessage }</p>
            }
          />
        </If>
      </If>
    </div>
  )
}

export default LoginEmpty
